import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDecision(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M71.338 58.784 64.65 65.48 77.72 76.12l4.266-4.257-10.647-13.078Z" fill="#007A5F" />
      <path
        d="M56.273 28.288 34.156 50.406l17.368 17.368 22.118-22.117-17.369-17.369Z"
        fill="#00664F"
      />
      <path d="M73.88 61.904v11.103l-9.24-7.526 6.698-6.697 2.543 3.12Z" fill="#007A5F" />
      <path d="M73.88 61.904v11.103l-9.24-7.526 6.698-6.697 2.543 3.12Z" fill="#00664F" />
      <path
        d="M104.722 98.855c2.133-2.133 2.002-5.635-.28-7.61L81.985 71.852l-4.266 4.266 19.393 22.458c1.974 2.282 5.477 2.412 7.61.28ZM58.035 64.727l12.553-12.554 1.015 1.015a4.62 4.62 0 0 1 0 6.533l-6.02 6.02a4.62 4.62 0 0 1-6.534 0l-1.014-1.014Z"
        fill="#007A5F"
      />
      <path
        d="m50.473 29.788-14.82 14.82 21.84 21.84 14.82-14.82-21.84-21.84ZM28.49 49.997l-1.607 1.607a3.726 3.726 0 0 0 0 5.269L44.929 74.92a3.726 3.726 0 0 0 5.27 0l1.607-1.607a3.726 3.726 0 0 0 0-5.27L33.759 49.998a3.726 3.726 0 0 0-5.27 0ZM57.477 21.01l-1.607 1.607a3.726 3.726 0 0 0 0 5.269l18.047 18.047a3.726 3.726 0 0 0 5.269 0l1.607-1.607a3.726 3.726 0 0 0 0-5.27L62.746 21.01a3.726 3.726 0 0 0-5.27 0Z"
        fill="#78B441"
      />
      <path
        d="M81.987 70.727a.8.8 0 0 1 1.131 1.133l-5.402 5.392a.8.8 0 0 1-1.131-1.131l5.402-5.394ZM35.675 44.628a.8.8 0 0 1 1.13 0l20.67 20.67a.8.8 0 0 1-1.131 1.131l-20.67-20.67a.8.8 0 0 1 0-1.13ZM50.495 29.809a.8.8 0 0 1 1.13 0l20.67 20.669a.8.8 0 0 1-1.131 1.132l-20.67-20.67a.8.8 0 0 1 0-1.131Z"
        fill="#0F172A"
      />
      <path
        d="M26.818 92.055h41.925a8.32 8.32 0 0 1 8.318 8.318H18.5c0-4.582 3.726-8.318 8.318-8.318Z"
        fill="#007A5F"
      />
      <path
        d="M34.8 87.11h25.97a4.96 4.96 0 0 1 4.955 4.955h-35.87a4.96 4.96 0 0 1 4.955-4.956h-.01Z"
        fill="#78B441"
      />
      <path d="M68.716 91.256a.8.8 0 0 1 0 1.6h-41.86a.8.8 0 1 1 0-1.6h41.86Z" fill="#0F172A" />
    </svg>
  )
}
export default wrapIllustration(SvgDecision)
